import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/burger_menu.svg")